export type SiteimproveEvent = {
    category: string;
    action: string;
    label?: string;
};

export function useSiteImproveTracking() {
    const pushEventToSiteImprove = (event: SiteimproveEvent) => {
        // @ts-ignore
        // eslint-disable-next-line no-underscore-dangle
        if (window._sz && typeof window._sz.push === 'function') {
            // @ts-ignore
            // eslint-disable-next-line no-underscore-dangle
            window._sz.push(['event', event.category, event.action, event.label]);
        } else {
            console.error('Siteimprove tracking script not loaded or not initialized properly.');
        }
    };

    return { pushEventToSiteImprove };
}
